'use client';

import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

interface Props {
  children: string;
  disabled?: boolean;
  icon?: Icon;
  onClick?: () => void;
  type?: 'submit' | 'reset' | 'button' | undefined;
}

const CardButton = ({
  children,
  disabled = false,
  icon,
  onClick = undefined,
  type = 'button',
}: Props) => {
  const className = classnames({
    'w-full': true,
    rounded: true,
    'bg-card-background-color': true,
    'text-card-text-color': true,
    border: true,
    'border-card-border-color': true,
    'py-1.5': true,
    'opacity-60': disabled,
  });

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      <span className="mr-2">
        <IconView icon={icon} size={'lg'} />
      </span>
      {children}
    </button>
  );
};

export default CardButton;
